<template>
  <div>
    <v-list two-line v-if="value">
      <v-list-item v-if="loading">
        <v-list-item-content>
          <v-progress-linear indeterminate />
        </v-list-item-content>
      </v-list-item>
      <template v-else>
        <v-list-item v-if="alterar" key="novo-doc">
          <v-list-item-content>
            <adicionar-documentos-dialog
              :url-base="urlBase"
              :adicionados="value"
              @adicionar="novosDocumentos($event)"
            />
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="value.length === 0">
          <v-list-item-content class="text-center">
            <i>Nenhum documento disponível</i>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="(doc, i) in value" :key="`doc-${i}`">
          <v-list-item-avatar color="grey lighten-2">
            <v-btn icon @click="download(doc)">
              <v-icon class="mdi mdi-download"></v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="d-flex align-center">
              <strong class="mr-1">{{ doc.tipo_documento.descricao }}</strong>
              {{ doc.registro }}
              <icone-lista-documento :documento="doc" class="ml-2" />
            </v-list-item-title>
            <v-list-item-subtitle>
              <vencimento-documento :documento="doc" :icon="true" />
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="alterar">
            <v-speed-dial direction="left" v-if="!doc.novo && !doc.remover">
              <template v-slot:activator>
                <v-btn depressed icon fab small>
                  <v-icon class="mdi mdi-dots-vertical" />
                </v-btn>
              </template>
              <v-btn icon @click="$store.commit('documento/editar', doc)">
                <v-icon>mdi-file-edit-outline</v-icon>
              </v-btn>
              <v-btn
                icon
                color="error"
                @click="$set(doc, 'remover', true)"
                title="Marcar documento para remoção"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-speed-dial>
            <v-btn
              v-if="doc.remover"
              icon
              @click="doc.remover = false"
              title="Recuperar documento"
            >
              <v-icon>mdi-undo</v-icon>
            </v-btn>
            <v-btn
              v-if="doc.novo"
              icon
              color="error"
              @click="removerNovo(doc)"
              title="Cancelar novo documento"
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
    <form-documento
      v-if="alterar"
      @change="changeDocumento($event)"
      :url-base="urlBase"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import FormDocumento from "./FormDocumento";
import IconeListaDocumento from "./IconeListaDocumento";
import AdicionarDocumentosDialog from "./AdicionarDocumentosDialog";
import VencimentoDocumento from "./VencimentoDocumento";
export default {
  components: {
    FormDocumento,
    IconeListaDocumento,
    AdicionarDocumentosDialog,
    VencimentoDocumento,
  },
  props: {
    urlBase: String,
    IdProprietario: [Number, String],
    alterar: Boolean,
    value: Array,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
  },
  mounted() {
    this.carregarDocumentos();
  },
  methods: {
    async carregarDocumentos() {
      if (!this.IdProprietario) {
        return;
      }

      this.loading = true;
      try {
        const payload = {
          urlBase: this.urlBase,
          IDProprietario: this.IdProprietario,
        };
        const docs = await this.$store.dispatch("documento/listar", payload);
        this.$emit("input", docs);
      } catch (err) {
        this.$emit("input", []);
      } finally {
        this.loading = false;
      }
    },
    async download(doc) {
      if (doc.novo) {
        return this.downloadNovo(doc);
      }
      try {
        const response = await this.$store.dispatch("documento/download", {
          urlBase: this.urlBase,
          doc,
        });
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (e) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível realizar o download do arquivo",
        });
      }
    },
    downloadNovo(doc) {
      const url = window.URL.createObjectURL(doc.arquivo);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    removerNovo(doc) {
      const docs = _.clone(this.value);
      const idx = docs.indexOf(doc);
      if (idx > -1) {
        docs.splice(idx, 1);
      }
      this.$emit("input", docs);
    },
    changeDocumento(doc) {
      let docs = _.clone(this.value);
      if (doc.novo) {
        docs.push(doc);
      } else {
        docs = docs.map((d) => (d.id === doc.id ? doc : d));
      }

      this.$emit("input", docs);
    },
    novosDocumentos(novos) {
      const docs = _.clone(this.value);
      novos.map((d) => {
        d.novo = true;
        docs.push(d);
      });
      this.$emit("input", docs);
    },
  },
  watch: {
    IdProprietario() {
      this.carregarDocumentos();
    },
    urlBase() {
      this.carregarDocumentos();
    },
  },
};
</script>
